module.exports = __webpack_public_path__ + "fonts/SuisseIntl-SemiBoldItalic.f6c2e43.woff2";